import { get } from './httpRequest';

// eslint-disable-next-line import/prefer-default-export
export const fetchIntercom = async () => {
  const response = await get('/setup-intercom');
  return response.data;
};
